// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1DL3d","description":"PatientConsentPreview_description__2xxOI"};